import { render, staticRenderFns } from "./CodeSnippets.vue?vue&type=template&id=315c3614&scoped=true&"
import script from "./CodeSnippets.vue?vue&type=script&lang=js&"
export * from "./CodeSnippets.vue?vue&type=script&lang=js&"
import style0 from "./CodeSnippets.vue?vue&type=style&index=0&id=315c3614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c3614",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VCol,VIcon})
